export const _points = [
  {
    id: '1',
    direction: 'in',
    value: 20,
    remainingValue: 10,
    createdAt: new Date('2022-08-17'),
    expirationDate: new Date('2025-09-17'),
    description: 'Scan de nota',
    location: 'VIVA CENTER NORTE',
    type: 'note',
  },
  {
    id: '2',
    direction: 'in',
    value: 40,
    remainingValue: 15,
    createdAt: new Date('2023-01-10'),
    expirationDate: new Date('2024-12-10'),
    description: 'Scan de nota',
    location: 'CAMICADO',
    type: 'mission',
  },
  {
    id: '3',
    direction: 'out',
    value: 30,
    remainingValue: 20,
    createdAt: new Date('2023-05-15'),
    expirationDate: new Date('2025-06-15'),
    description: 'experiência',
    location: 'NIKE',
    type: 'note',
    accelerator: 2,
  },
  {
    id: '4',
    direction: 'out',
    value: 40,
    remainingValue: 15,
    createdAt: new Date('2023-10-01'),
    expirationDate: new Date('2023-12-01'),
    description: 'Cupom',
    location: 'ADIDAS',
    type: 'mission',
  },
  {
    id: '5',
    direction: 'out',
    value: 10,
    remainingValue: 0,
    createdAt: new Date('2022-11-20'),
    expirationDate: new Date('2022-12-20'),
    description: 'Experiência',
    location: 'NIKE',
    type: 'note',
  },
];

export const _pointDetails = {
  direction: 'out',
  value: 30,
  remainingValue: 20,
  createdAt: new Date('2023-05-15'),
  expirationDate: new Date('2025-06-15'),
  description: 'experiência',
  location: 'NIKE',
  type: 'note',
  accelerator: 2,
};

export const _notesList = [
  {
    id: '1',
    location: 'NIKE',
    date: new Date('2024-12-24T13:30:00'),
    status: 'valid_note',
    iconType: 'qr_code',
  },
  {
    id: '2',
    location: 'GRAND CRU',
    date: new Date('2024-12-24T13:30:00'),
    status: 'partial',
    iconType: 'qr_code',
  },
  {
    id: '3',
    location: 'BOTOCLINIC',
    date: new Date('2024-12-24T13:30:00'),
    status: 'invalid',
    iconType: 'qr_code',
  },
  {
    id: '1',
    location: 'MADERO',
    date: new Date('2024-12-24T13:30:00'),
    status: 'analysis',
    iconType: 'photo',
  },
  {
    id: '1',
    location: 'MADERO',
    date: new Date('2024-12-24T13:30:00'),
    status: 'analysis',
    iconType: 'photo',
  },
];

export const translateTier: Record<string, string> = {
  'silver': 'Prata',
  'gold': 'Ouro',
  'diamond': 'Diamante'
} 

export const _pointsNotificationMock = {
    remainingTime: 5,
    notify: true,
    notificationData: {
      type: 'pointsModal',
      validatedPoints: 1200,
      remainingPoints: 800,
      nextTier: 'diamond',
    }
};